'use client';

import { useState, useEffect } from 'react';

function useDebounce(value, delay) {
  // State to hold the debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Create a timeout to set the debounced value after the specified delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cleanup the timeout if the component unmounts or if value changes before the delay
    return () => clearTimeout(handler);
  }, [value, delay]); // Dependencies array: the effect will run again if `value` or `delay` change

  return debouncedValue;
}

export default useDebounce;